export const roleLabels: Record<string, string> = {
  Owner: 'Tulajdonos',
  Assistant: 'Asszisztens',
  Employee: 'Alkalmazott',
  Subcontractor: 'Alvállalkozó',
  SubcontractorManager: 'Alvállalkozói menedzser',
  AiAgent: 'AI Olvasó Munkatárs',
  AiTalentWriter: 'AI Író Munkatárs'
};

export function getRoleLabel(role: string) {
  return roleLabels[role] ?? role;
}
